import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=5675d890"
import script from "../../services/teacher/invoice-detail.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/invoice-detail.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/invoice/invoice-detail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports